import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wells-data-tab',
    standalone: false,
    template: `
        <div class="wells-tab-content">
            <h3>{{ title }}</h3>
            <p>This is the Wells Plug and Abandonment data interface. 
               The well selection and data grid are now integrated directly into the main home page above.</p>
            
            <div class="info-cards">
                <div class="info-card">
                    <h4>Real-time Data</h4>
                    <p>Access live well performance metrics and operational data.</p>
                </div>
                
                <div class="info-card">
                    <h4>Schema Management</h4>
                    <p>View and edit well configuration schemas with engineer suggestions.</p>
                </div>
                
                <div class="info-card">
                    <h4>Analytics Dashboard</h4>
                    <p>Comprehensive analytics and visualization tools for well data.</p>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .wells-tab-content {
            padding: 20px;
            
            h3 {
                font-family: 'GothamBold', sans-serif;
                color: var(--blue-dark, #003f5c);
                margin-bottom: 15px;
            }
            
            p {
                font-family: 'GothamNarrowBook', sans-serif;
                line-height: 1.6;
                margin-bottom: 25px;
            }
            
            .info-cards {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                gap: 20px;
                
                .info-card {
                    background: var(--white, #ffffff);
                    border: 1px solid var(--gray-light, #e0e0e0);
                    border-radius: 6px;
                    padding: 20px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    
                    h4 {
                        font-family: 'GothamBold', sans-serif;
                        color: var(--blue, #007bff);
                        margin-bottom: 10px;
                    }
                    
                    p {
                        margin: 0;
                        font-size: 0.9em;
                    }
                }
            }
        }
    `]
})
export class WellsDataTabComponent {
    @Input() title: string = "Wells Data Overview";
    @Output() tabChangedEvent = new EventEmitter<boolean>();
}
